var React = require('react');

function IconArrowRight (props) {
    return React.createElement("svg",props,React.createElement("g",null,React.createElement("g",null,React.createElement("polygon",{"fillRule":"evenodd","clipRule":"evenodd","points":"6.5,2 5.5,3 10.5,8 5.5,13 6.5,14 12.5,8 \t\t"}))));
}

IconArrowRight.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","width":"16px","height":"16px","viewBox":"0 0 16 16","enableBackground":"new 0 0 16 16","xmlSpace":"preserve"};

module.exports = IconArrowRight;

IconArrowRight.default = IconArrowRight;
